<template>
    <HeaderComponent></HeaderComponent>
    <div v-if="dataLoaded">
        <router-view/>
    <!-- <br>
    <span style="display: flex;justify-content: center;"><img src="preparing.png" width="250"></span> -->
    </div>
    <div v-else>
        <div class="d-flex align-items-center justify-content-center" style="height:200px">
        <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
        </div>
        </div>
    </div>

</template>

<script setup>
import HeaderComponent from '@/components/HeaderComponent.vue'
import { ref, onMounted } from 'vue';
import { ref as fbRef, getDatabase, child, get } from "firebase/database"
import { getAuth, signInAnonymously } from "firebase/auth";

const db = getDatabase();
const dbRef = fbRef(db);
const auth = getAuth();
const dataLoaded = ref(false);

onMounted(async() => {
    // Anonymous login まだ必要ない
    // auth.onAuthStateChanged(async (user) => {
    //     if (!user) {
    //         signInAnonymously(auth)
    //         .then(() => {
    //             console.log("anonymous user")
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         });
    //     }
    // });

    await fetchTeams();
    fetchEvents();
    fetchEntries();
    await fetchMatches();

    dataLoaded.value = true;
})

const fetchMatches = async () => {
    await get(child(dbRef, '/2026-summer/matches')).then((snapshot) => {
        if (snapshot.exists()) {
            localStorage.setItem('matches', JSON.stringify(snapshot.val()));
            console.log("match loaded")
        } else {
            console.log('No match data')
        }
    }).catch((error) => {
        console.error(error)
    })
};

const fetchEntries = () => {
    get(child(dbRef, '/2026-summer/entries')).then((snapshot) => {
        if (snapshot.exists()) {
            localStorage.setItem('entries', JSON.stringify(snapshot.val()));
        } else {
            console.log('No entry data')
        }
    }).catch((error) => {
        console.error(error)
    })
};

const fetchEvents = () => {
    get(child(dbRef, '/2026-summer/events')).then((snapshot) => {
        if (snapshot.exists()) {
            localStorage.setItem('events', JSON.stringify(snapshot.val()));
        } else {
            console.log('No event data')
        }
    }).catch((error) => {
        console.error(error)
    })
};

const fetchTeams = async() => {
    await get(child(dbRef, '/2026-summer/teams')).then((snapshot) => {
        if (snapshot.exists()) {
            localStorage.setItem('teams', JSON.stringify(snapshot.val()));
        } else {
            console.log('No team data')
        }
    }).catch((error) => {
        console.error(error)
    })
};

</script>

<style>
@media screen and (max-width: 768px) {

    .page-title {
        font-size: 12pt;
    }

    #result-tbl {
        font-size: 10pt;
    }

    #result-tbl td {
        padding-left: 1px;
        padding-right: 1px;
        margin: 0px;
    }

    .result-tbl-width {
        width: 25px;
    }

    .sp-view {
        display: inline;
    }

    .pc-view {
        display: none;
    }

}

.firebase-emulator-warning { display: none; }

</style>
